import { takeEvery } from 'redux-saga/effects';
import deleteFAQAPi from '../../api/deleteFAQ';

function* waitForFetchProducts() {
    yield takeEvery('deleteFAQ', deleteFAQAPi)
}

export default waitForFetchProducts;